import React, { useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';

import { routeToSpecificScope, text_truncate } from '../../../../helpers';
import { FILTER_KEYS, SHOW_DISTANCE_GRAPHS } from '../../../../config/constants';
import { useFiltersDispatch, useFiltersState } from '../../../../store/hooks';
import { BasicFilterPropsType } from '../type';
import { useRouter } from '../../../../helpers/customHooks';

import '../SimpleSelector/styles.scss';

const ShowDistanceGraph = ({ forceScope, show, close, open }: BasicFilterPropsType) => {

  const { pathname } = useRouter();
  const specificScope = forceScope || routeToSpecificScope(pathname);
  const { [FILTER_KEYS.SHOW_DISTANCE_GRAPHS]: selectedItem } = useFiltersState(specificScope, FILTER_KEYS.SHOW_DISTANCE_GRAPHS);
  const { changeFilterData } = useFiltersDispatch();
  const [appliqued, setAppliqued] = useState(false);
  const [optionSelected, setOptionSelected] = useState(selectedItem);
  const [showGraphs, setShowGraphs] = useState(!!selectedItem);

  const li: JSX.Element[] = [];
  SHOW_DISTANCE_GRAPHS.types.forEach((type) => {
    const isSelected = JSON.stringify(optionSelected) === JSON.stringify(type);
    li.push(
      <li key={(specificScope ? specificScope + '-' : '') + JSON.stringify(type)}
          className="li-simple-selector"
          style={{ padding: '8px 10px', background: isSelected ? '#F2F5F7' : undefined }}>
        <div className="radio" style={{ fontSize: '12px' }}>
          <input
            id={(specificScope ? specificScope + '-' : '') + 'radio-' + JSON.stringify(type)}
            name={(specificScope ? specificScope + '-' : '') + `radio-${type.name}`}
            type="radio"
            checked={isSelected}
            onChange={() => {
              setOptionSelected(type);
              setShowGraphs(true);
            }} />
          <label
            htmlFor={(specificScope ? specificScope + '-' : '') + 'radio-' + JSON.stringify(type)}
            style={{ fontWeight: isSelected ? 'bold' : undefined }}
            className="radio-label"
          >
            {type.name}
          </label>
        </div>
      </li>
    );
  });
  const onOpen = () => {
    open();
    setOptionSelected(selectedItem);
    setShowGraphs(!!selectedItem);
  };
  const onApply = () => {
    close();
    setAppliqued(true);
    changeFilterData(optionSelected!, FILTER_KEYS.SHOW_DISTANCE_GRAPHS, specificScope)();
  };

  return (
    <Dropdown show={show} onToggle={show ? close : onOpen}>
      <Dropdown.Toggle id="dropdown-basic" className="btn-border more-arrow-after distance-graph-width" style={{ width: '160px' }}>
        <label className={appliqued ? 'appliqued' : ''}>{SHOW_DISTANCE_GRAPHS.title}</label>
        {selectedItem ? 'Show: ' + text_truncate(selectedItem.name, 12) : 'Select to Enable'}
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="simple-selector-dropdown-menu"
        style={{ width: '165px', minWidth: '165px', height: '252px' }}
      >
        <div className="p-h-01" style={{ padding: '9px 15px' }}>
          Show Graphs
          <div className="p-i-01" style={{ top: '6px' }}>
            <input
              type="checkbox" id={specificScope + '-show-graphs'}
              name="set-name"
              className="switch-input"
              checked={showGraphs}
              onChange={() => {
                if (showGraphs) {
                  setOptionSelected(null);
                } else {
                  setOptionSelected(SHOW_DISTANCE_GRAPHS.types[0]);
                }
                setShowGraphs(!showGraphs);
              }}
            />
            <label htmlFor={specificScope + '-show-graphs'} className="switch-label" />
          </div>
        </div>
        <ul className="ul-simple-selector scroll-style-zebra-sports">
          {li}
        </ul>
        <div className="footer-s">
          <Button className="btn-transparet" onClick={close}>Cancel</Button>
          <Button className="btn-blue" onClick={onApply}>Apply</Button>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ShowDistanceGraph;
export * from './types';
